import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Divider from '@material-ui/core/Divider';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Switch from '@material-ui/core/Switch';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutlineOutlined';

const PurpleSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: green[500],
        borderColor: green[500],
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

const Actions = ({ classes }) => {
  const [state, setState] = useState({
    checkedA: true,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (<div className={classes.icons} onClick={(e)=> e.stopPropagation()}>
      <FormControlLabel
          control={
            <PurpleSwitch checked={state.checkedA} onChange={handleChange} name="checkedA" />
          }
      />
      <EditOutlinedIcon className="mr-2" color="secondary" fontSize="small"/>
      <Divider classes={{ root: classes.divider }} orientation="vertical" light={true} flexItem/>
      <DeleteOutlineIcon className="ml-2" color="secondary" fontSize="small"/>
  </div>)
};

const FaqList = (props) => {
  const classes = props.classes;
  
  return (<div className={classes.wrap}> 
    { [1,2,3,4,5,6,7,8,9,10].map(()=> (<Accordion classes={{ root: 'mb-2' }}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon/>}
      aria-label="Expand"
      aria-controls="additional-actions1-content"
      id="additional-actions1-header"
      classes={{ content: classes.content }}
    >
      <FormControlLabel
        aria-label="Acknowledge"
        onClick={(event) => event.stopPropagation()}
        onFocus={(event) => event.stopPropagation()}
        control={<MoreVertIcon color="secondary" classes={{ root: 'mr-4 ml-3' }}/>}
        label="I acknowledge that I should stop the click event propagation?"
      />
      <Actions classes={classes}/>
    </AccordionSummary>
    <AccordionDetails>
      <Typography color="textSecondary">
        The click event of the nested action will propagate up and expand the accordion unless
        you explicitly stop it.
      </Typography>
    </AccordionDetails>
  </Accordion>)) }
   </div>)
};

export default FaqList;
